import ru from "./ru.json";
import uz from "./uz.json";

export type Lang = "uz" | "ru";
export const LANGS: Lang[] = ["uz", "ru"];
export type Dict = Record<string, string>;

export const dictionaries: Record<Lang, Dict> = { uz, ru };

/** `t("key", {n: 3})` — `{n}` o'rniga qiymat qo'yiladi. Kalit topilmasa uz, keyin kalitning o'zi. */
export function translate(lang: Lang, key: string, vars?: Record<string, string | number>): string {
  const raw = dictionaries[lang][key] ?? dictionaries.uz[key] ?? key;
  return vars ? raw.replace(/\{(\w+)\}/g, (_, k: string) => String(vars[k] ?? `{${k}}`)) : raw;
}

export function detectLang(saved: string | null | undefined, navigatorLang?: string): Lang {
  if (saved === "uz" || saved === "ru") return saved;
  return navigatorLang?.toLowerCase().startsWith("ru") ? "ru" : "uz";
}
